// src/pages/ForgotPasswordPage.js
import React, { useState } from 'react';
import { Form, Button, Alert } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import AuthLayout from '../components/auth/AuthLayout';
import '../components/css/ForgotPasswordPage.css';
import { forgotPasswordOtpApi,resetPasswordApi,verifyForgotPasswordOtpApi } from '../services/api';
import Swal from 'sweetalert2';
import { useNavigate } from 'react-router-dom';


const ForgotPasswordPage = () => {
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState('');
  const [loading, setLoading] = useState(false);
  const [isError, setIsError] = useState(false);
  const [otp, setOtp] = useState('');
const [password, setPassword] = useState('');
const [otpSent, setOtpSent] = useState(false);
const [otpVerified, setOtpVerified] = useState(false);
const navigate = useNavigate();


  const handleForgotPassword = async (e) => {
  e.preventDefault();

  setMessage('');
  setIsError(false);
  setLoading(true);

  try {
    const { data } = await forgotPasswordOtpApi({
      email,
    });

    setMessage(data.message || 'OTP sent successfully.');
    setOtpSent(true);
    setIsError(false);

  } catch (err) {
    setMessage(
      err.response?.data?.message ||
      'Failed to send OTP.'
    );
    setIsError(true);

  } finally {
    setLoading(false);
  }
};


const handleResetPassword = async () => {
  try {
    const { data } = await resetPasswordApi({
      email,
      otp,
      password
    });

    setIsError(false);

    Swal.fire({
      icon: 'success',
      title: 'Password Reset Successful',
      text: 'Redirecting to Login Page...',
      timer: 3000,
      showConfirmButton: false
    });

    setTimeout(() => {
      navigate('/login');
    }, 3000);

  } catch (err) {
    setMessage(
      err.response?.data?.message ||
      "Failed to reset password"
    );
    setIsError(true);
  }
};

const handleVerifyOtp = async () => {
  try {
    const { data } = await verifyForgotPasswordOtpApi({
      email,
      otp
    });

    setIsError(false);

    Swal.fire({
      icon: 'success',
      title: 'OTP Verified',
      text: 'Please change your password',
      timer: 2000,
      showConfirmButton: false
    });

    setTimeout(() => {
      setMessage('');
      setOtpVerified(true);
    }, 2000);

  } catch (err) {
    setMessage(
      err.response?.data?.message ||
      "Invalid OTP"
    );
    setIsError(true);
  }
};

  return (
    <AuthLayout
      pageTitle="Forgot Password - BOOKMYAUDITION"
      metaDescription="Reset your BOOKMYAUDITION account password."
      sidebarTitle="FORGOT PASSWORD"
      sidebarText="Don't Worry. We've got you back."
      sidebarLink="/register" // Or /login
      sidebarLinkText="Register" // Or "Back to Login"
       className="forgot-password-auth-layout" 
    >
      <Form onSubmit={handleForgotPassword}>
        {message && <Alert variant={isError ? "danger" : "success"} className="py-2 small">{message}</Alert>}
        <Form.Group className="mb-4" controlId="forgotEmail"> {/* mb-30 in original */}
          <Form.Control
            type="email"
            placeholder="Email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
            className="form-ctrl-login-custom"
          />
        </Form.Group>

       {!otpSent && (
          <Button
            variant="outline-dark"
            type="submit"
            className="w-100 btn-lg text-uppercase"
            disabled={loading}
            style={{
              color: "#fff",
              borderColor: "#495057",
              background: "linear-gradient(135deg, #c30000 0%, #b33a3a 100%)"
            }}
          >
            {loading ? 'Sending...' : 'Get a new password'}
          </Button>
        )}

            {otpSent && !otpVerified && (
          <>
            <Form.Group className="mt-3">
              <Form.Control
                type="text"
                placeholder="Enter OTP"
                value={otp}
                onChange={(e) => setOtp(e.target.value)}
              />
            </Form.Group>

            <Button
           className="btn-auth-primary w-100 mt-3"
          type="button"
          onClick={handleVerifyOtp}
        >
          Verify OTP
        </Button>
          </>
        )}



        {otpVerified && (
          <>
            <Form.Group className="mt-3">
              <Form.Control
                type="password"
                placeholder="New Password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
              />
            </Form.Group>

            <Button
              type="button"
              className="btn-auth-primary w-100 mt-3"
              onClick={handleResetPassword}
            >
              Reset Password
            </Button>
          </>
        )}
      
        <p className="auth-footer-link text-secondary text-center mt-4 mb-0 small">
            Already have an account? <Link to="/login" className="text-red text-decoration-none fw-bold">Sign in</Link>
        </p>
      </Form>
    </AuthLayout>
  );
};

export default ForgotPasswordPage;